/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Cashbackdescription1Inputs */

const en_cashbackdescription1 = /** @type {(inputs: Cashbackdescription1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Credits your share links have earned. Each payout expires after ${i?.days} days and is kept by the monthly refill.`)
};

const de_cashbackdescription1 = /** @type {(inputs: Cashbackdescription1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Credits, die deine Teilen-Links verdient haben. Jede Gutschrift verfällt nach ${i?.days} Tagen und bleibt beim monatlichen Auffüllen erhalten.`)
};

/**
* | output |
* | --- |
* | "Credits your share links have earned. Each payout expires after {days} days and is kept by the monthly refill." |
*
* @param {Cashbackdescription1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cashbackdescription1 = /** @type {((inputs: Cashbackdescription1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashbackdescription1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cashbackdescription1(inputs)
	return de_cashbackdescription1(inputs)
});
export { cashbackdescription1 as "cashbackDescription" }